import React from "react";
import image1 from '../mainSection/aboutPage/allAboutImages/images.png'
import image2 from '../mainSection/aboutPage/allAboutImages/14.png'
import image3 from '../mainSection/aboutPage/allAboutImages/Carousel3.jpeg'
import image4 from '../mainSection/aboutPage/allAboutImages/Carousel6.png'
import image5 from '../mainSection/aboutPage/allAboutImages/Carousel7.jpeg'
import image6 from './aboutPage/allAboutImages/New Project -6-.png'
import image7 from './aboutPage/allAboutImages/New Project -7-.png'
import image8 from './aboutPage/allAboutImages/12 -1-.jpeg'
import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay, Pagination } from 'swiper/modules';

import 'swiper/css';
import 'swiper/css/pagination';

const testimonials = [
  {
    id: 1,
    name: "ONGC",
    title: "",
    quote:
      "We've been working together with TekIT Solution for more than 01 year now and it is has been a very positive experience for me and my company. TekIT Solution has been a trusted partner and always willing to help resolve the most complex of issues. The quality of the coding and in general work done has been very high. I would recommend them.",
    image: image1,
    rotation: "hover:rotate-0 rotate-[3deg]",
    hoverRotation: "rotate-[0deg]",
  },
  {
    id: 2,
    name: "Apni Dukan",
    title: "",
    quote:
      "TekIT Solution has not only met my expectations, they have exceeded them. I have provided most of the specs for the project which is application, which they have executed faithfully. I can highly recommend this company which has at all times in the development cycle of our project has met.",
    image: image2,
    rotation: "hover:rotate-0 -rotate-[2deg]",
    hoverRotation: "rotate-[0deg]",
  },
  {
    id: 3,
    name: "Ganesh Agro",
    title: "",
    quote:
      "TekIT Solution has done a great job taking our company's ideas and developing a website as per our niche specifications. The team is technicaly strong and creative. I'll not hesitate to recommend them.",
    image:image3,
    rotation: "hover:rotate-0 rotate-[3deg]",
    hoverRotation: "rotate-[0deg]",
  },
  {
    id: 4,
    name: "Lalitpur Municipal Corporation",
    title: "",
    quote:
      "We have been working with TekIT Solution for two years to develop a software application that supports the company’s daily activities. The TekIT Solution team is highly responsive and professional providing us with great problem solving on a daily basis. They are a tremendous extension of our team.",
    image: image4,
    rotation: "hover:rotate-0 -rotate-[2deg]",
    hoverRotation: "rotate-[0deg]",
  },
  {
    id: 5,
    name: "AIIMS, New Delhi",
    title: "",
    quote:
      "We trust TekIT. We are using the multiple Applications developed by TekIT as per our requirement. These Applications helped us in automating the traditional manual processes and we achieved a hike in overall efficiency.",
    image: image5,
    rotation: "hover:rotate-0 -rotate-[2deg]",
    hoverRotation: "rotate-[0deg]",
  },
  {
    id: 6,
    name: "Alankaram",
    title: "",
    quote:
      "TekIT Solution keeps doing what comes naturally to them which is building teams with their clients, partners and creating exceptional software development and support. Job well done. I have used them since 2018 for offshore development. Congratulations to all your teams.",
    image: image6,
    rotation: "hover:rotate-0 -rotate-[2deg]",
    hoverRotation: "rotate-[0deg]",
  },
  {
    id: 7,
    name: "Armaf",
    title: "",
    quote:
      "At Armaf, we are a couture collection of luxury french perfumes designer fragrances that exude class, style & elegance. TekIT provided us with an effective online sales platform and suggested us with strategic sales approach which accelerated our business. ",
    image: image7,
    rotation: "hover:rotate-0 -rotate-[2deg]",
    hoverRotation: "rotate-[0deg]",
  },
  {
    id: 8,
    name: "Pinkz Fashion Boutique",
    title: "",
    quote:
      "We were recommended to TekIT Solution by another company to look after our Digital Marketing. Since retaining them, they have managed our Digital Marketing Services",
    image: image8,
    rotation: "hover:rotate-0 -rotate-[2deg]",
    hoverRotation: "rotate-[0deg]",
  },
];

const Testimonials = () => {
  return (
    <>
    <section id="testimonials" className="py-20 font-recoleta ">
      <div className="text-center mb-16 px-4">
        <h2 className="text-[64px] 2xl:text-[40px] lg:text-[36px]  font-black leading-tight tracking-tight text-cyan-400 font-sans">
        Trusted by Clients Worldwide !
        </h2>
      </div>

      <div className="px-4 max-w-6xl mx-auto">
  <Swiper
  modules={[Autoplay, Pagination]}
    spaceBetween={20}
    slidesPerView={1}
    loop={true}
    autoplay={{ delay: 3000 }}
    pagination={{ clickable: true }}
    breakpoints={{
      768: { slidesPerView: 1 },
      1024: { slidesPerView: 3 },
    }}
  >
    {testimonials.map((testimonial) => (
      <SwiperSlide key={testimonial.id} >
        <div
          className={`bg-white  lg:block hidden border hover:bg-gradient-to-b hover:from-white border-black/5 rounded-[18px] shadow-lg p-6 w-full lg:max-w-md transform ${testimonial.rotation} transition-all duration-500 hover:opacity-100 hover:translate-x-[10px] hover:translate-y-[10px] hover:shadow-[inset_0_0.5px_0.5px_-1.25px_rgba(0,0,0,0.68),inset_0_-2px_2px_-2.5px_rgba(0,0,0,0.6),inset_0_8px_8px_-3.75px_rgba(0,0,0,0.2)] bg-white hover:bg-cyan-600 rounded-[17.55px] border-[3.51px] border-solid border-[rgba(0,0,0,0.04)]`}
        >
          <div className="flex flex-col 2xl:h-[450px] lg:h-[350px] items-center text-center w-full ">
            <div className="lg:-rotate-3 w-28 h-28 rounded-[12px] overflow-hidden shadow-md border border-gray-200">
              <img
                src={testimonial.image}
                alt={testimonial.name}
                className="w-full h-full object-cover"
              />
            </div>
            <p className="text-[30px] lg:text-[14px] 2xl:text-[18px] font-handwriting text-gray-700 leading-relaxed mt-4">
              {testimonial.quote}
            </p>
            <div className="text-[30px] lg:text-[18px]">
              <p className="text-sm font-medium text-gray-900">
                {testimonial.name}
              </p>
              <p className="text-gray-600">{testimonial.title}</p>
            </div>
          </div>
        </div>
        <div
          className={`bg-white border lg:hidden block hover:bg-gradient-to-b hover:from-white border-black/5 rounded-[18px] shadow-lg p-6 w-full lg:max-w-md transform  transition-all duration-500 hover:opacity-100 hover:translate-x-[10px] hover:translate-y-[10px] hover:shadow-[inset_0_0.5px_0.5px_-1.25px_rgba(0,0,0,0.68),inset_0_-2px_2px_-2.5px_rgba(0,0,0,0.6),inset_0_8px_8px_-3.75px_rgba(0,0,0,0.2)] bg-white hover:bg-cyan-600 rounded-[17.55px] border-[3.51px] border-solid border-[rgba(0,0,0,0.04)]`}
        >
          <div className="flex flex-col items-center text-center h-[450px] 2xl:w-[300px] w-full lg:w-[170px]">
            <div className="lg:-rotate-3 w-40 h-40 rounded-[12px] overflow-hidden shadow-md border border-gray-200">
              <img
                src={testimonial.image}
                alt={testimonial.name}
                className="w-full h-full object-cover"
              />
            </div>
            <p className="text-[30px] lg:text-[14px] 2xl:text-[18px] font-handwriting text-gray-700 leading-relaxed mt-4">
              {testimonial.quote}
            </p>
            <div className="text-[30px] lg:text-[18px]">
              <p className=" text-[24px] font-medium text-gray-900">
                {testimonial.name}
              </p>
              <p className="text-gray-600 ">{testimonial.title}</p>
            </div>
          </div>
        </div>
      </SwiperSlide>
    ))}
  </Swiper>
</div>


      {/* <div className="flex flex-col md:flex-row justify-center items-center gap-2 px-4 max-w-6xl mx-auto">
        {testimonials.map((testimonial) => (
          <div
            key={testimonial.id}
            className={`bg-white border hover:bg-gradient-to-b hover:from-white  border-black/5 rounded-[18px] shadow-lg p-6 w-full max-w-md transform ${testimonial.rotation}  transition-all duration-500 hover:opacity-100 hover:translate-x-[10px] hover:translate-y-[10px] hover:shadow-[inset_0_0.5px_0.5px_-1.25px_rgba(0,0,0,0.68),inset_0_-2px_2px_-2.5px_rgba(0,0,0,0.6),inset_0_8px_8px_-3.75px_rgba(0,0,0,0.2)] bg-white hover:bg-cyan-600 rounded-[17.55px] border-[3.51px] border-solid border-[rgba(0,0,0,0.04)] `}
            
          >
            <div className="flex flex-col items-center text-center h-[450px] 2xl:w-[300px] lg:w-[170px]">
              <div className="-rotate-3 w-28 h-24 rounded-[12px] overflow-hidden shadow-md border border-gray-200">
                <img
                  src={testimonial.image}
                  alt={testimonial.name}
                  className="w-full h-full object-cover"
                />
              </div>
              <p className="text-[30px] lg:text-[14px] 2xl:text-[18px] font-handwriting text-gray-700 leading-relaxed mt-4">
                {testimonial.quote}
              </p>
              <div className="text-[30px] lg:text-[18px]">
                <p className="text-sm font-medium text-gray-900">
                  {testimonial.name}
                </p>
                <p className=" text-gray-600 ">{testimonial.title}</p>
              </div>
            </div>
          </div>
        ))}
      </div> */}
    </section>

    {/* <section id="testimonials" className="py-20 font-recoleta block lg:hidden">
      <div className="text-center mb-16 px-4">
        <h2 className="text-[64px] 2xl:text-[40px] lg:text-[36px]  font-black leading-tight tracking-tight text-cyan-400 font-sans">
        Trusted by Clients Worldwide !
        </h2>
      </div>

      <div className=" justify-center items-center gap-2 px-4">
        {testimonials.map((testimonial) => (
          <div
            key={testimonial.id}
            data-cursor='check'
            className={`bg-white border hover:bg-gradient-to-b  border-black/5 rounded-[18px] shadow-lg p-6 w-full max-w-3xl transform ${testimonial.rotation}  transition-all duration-500 hover:opacity-100 hover:translate-x-[10px] bg-white rounded-[17.55px] border-[3.51px] border-solid border-[rgba(0,0,0,0.04)] justify-self-center mt-[24px]`}
            
          >
            <div className="">
              <div className="-rotate-3 w-28 h-24 rounded-[12px] overflow-hidden shadow-md border border-gray-200">
                <img
                  src={testimonial.image}
                  alt={testimonial.name}
                  className="w-full h-full object-cover"
                />
              </div>
              <p className="text-[30px] lg:text-[14px] 2xl:text-[18px] font-handwriting text-gray-700 leading-relaxed mt-4">
                {testimonial.quote}
              </p>
              <div className="mt-4">
                <p className="text-[30px] lg:text-[18px] font-medium text-gray-900">
                  {testimonial.name}
                </p>
                <p className=" text-gray-600 text-[40px]">{testimonial.title}</p>
              </div>
            </div>
          </div>
        ))}
      </div>
    </section> */}
   
    </>
  );
};

export default Testimonials;
